export default __webpack_public_path__ + "static/media/basic-preparation.2666e26a.jpg";